export default function getCssVariable(variable) {
    return getComputedStyle(document.body).getPropertyValue(variable);
}